import {
    apiRequest,
    salaryList,
    salaryActive,
    salaryInactive
} from "../../../../../services/adapters/master/salaryService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", salaryList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", salaryInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", salaryActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository